var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResumeMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 8.33317H1.66634C1.2061 8.33317 0.833008 7.96007 0.833008 7.49984V2.46359C0.852428 2.01757 1.2199 1.66608 1.66634 1.6665H8.33301C8.79325 1.6665 9.16634 2.0396 9.16634 2.49984V7.49984C9.16634 7.96007 8.79325 8.33317 8.33301 8.33317ZM1.66634 3.27817V7.49984H8.33301V3.27817L4.99967 5.49984L1.66634 3.27817ZM1.99967 2.49984L4.99967 4.49984L7.99968 2.49984H1.99967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeMailIcon);
export default __webpack_public_path__ + "static/media/resume-mail-icon.88bb8463605dd0766d9d1bc78be77f97.svg";
export { ForwardRef as ReactComponent };